module.exports = __webpack_public_path__ + "img/play-icon.75e10f85.svg";